import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../config/apiUrl';
import api from '../../services/api';
import './styles.css';

const PesquisaSatisfacao = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    comoConheceu: '',
    comoConheceuOutro: '',
    recebeuOrcamento: false,
    quantidadeOrcamentos: '',
    orcamentosTransformados: '',
    recebeuPremio: '',
    facilidadeUso: 0,
    dificuldadeUsoMotivo: '',
    qualidadeClientes: 0,
    qualidadeClientesMotivo: '',
    telefoneSucesso: '',
    sugestoesMelhorias: ''
  });

  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post(API_URL.PESQUISA_SATISFACAO.url, formData);

      if (response.data) {
        navigate('/');
      }
    } catch (error) {
      console.error('Erro:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pesquisa-container">
      <div className="pesquisa-header">
        <h1>FORMULÁRIO | PESQUISA DE SATISFAÇÃO ACHE SEU PINTOR</h1>
        <div className="tag-comunicacao">TAG COMUNICAÇÃO</div>
      </div>

      <form onSubmit={handleSubmit} className="pesquisa-form">
        <div className="form-section">
          <h3>● Como você conheceu o Ache Seu Pintor?</h3>
          <div className="radio-group">
            <label>
              <input
                type="radio"
                name="comoConheceu"
                value="Redes sociais"
                onChange={handleInputChange}
              />
              ☐ Redes sociais
            </label>
            <label>
              <input
                type="radio"
                name="comoConheceu"
                value="Indicação"
                onChange={handleInputChange}
              />
              ☐ Indicação
            </label>
            <label>
              <input
                type="radio"
                name="comoConheceu"
                value="Pesquisa no Google"
                onChange={handleInputChange}
              />
              ☐ Pesquisa no Google
            </label>
            <label>
              <input
                type="radio"
                name="comoConheceu"
                value="outro"
                onChange={handleInputChange}
              />
              ☐ Outro: 
              <input
                type="text"
                name="comoConheceuOutro"
                value={formData.comoConheceuOutro}
                onChange={handleInputChange}
                placeholder="________"
                className="inline-input"
              />
            </label>
          </div>
        </div>

        <div className="form-section">
          <h3>● Você já recebeu algum orçamento de cliente através da plataforma?</h3>
          <div className="radio-group">
            <label>
              <input
                type="radio"
                name="recebeuOrcamento"
                value="true"
                onChange={handleInputChange}
              />
              ☐ Sim
            </label>
            <label>
              <input
                type="radio"
                name="recebeuOrcamento"
                value="false"
                onChange={handleInputChange}
              />
              ☐ Não
            </label>
          </div>
        </div>

        {formData.recebeuOrcamento === 'true' && (
          <>
            <div className="form-section">
              <h3>● Caso sim, quantos orçamentos você recebeu nos últimos 3 meses?</h3>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="quantidadeOrcamentos"
                    value="1 a 3"
                    onChange={handleInputChange}
                  />
                  ☐ 1 a 3
                </label>
                <label>
                  <input
                    type="radio"
                    name="quantidadeOrcamentos"
                    value="4 a 6"
                    onChange={handleInputChange}
                  />
                  ☐ 4 a 6
                </label>
                <label>
                  <input
                    type="radio"
                    name="quantidadeOrcamentos"
                    value="Mais de 6"
                    onChange={handleInputChange}
                  />
                  ☐ Mais de 6
                </label>
              </div>
            </div>

            <div className="form-section">
              <h3>● Quantos desses orçamentos se transformaram em serviço fechado?</h3>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="orcamentosTransformados"
                    value="Nenhum"
                    onChange={handleInputChange}
                  />
                  ☐ Nenhum
                </label>
                <label>
                  <input
                    type="radio"
                    name="orcamentosTransformados"
                    value="1 a 2"
                    onChange={handleInputChange}
                  />
                  ☐ 1 a 2
                </label>
                <label>
                  <input
                    type="radio"
                    name="orcamentosTransformados"
                    value="3 ou mais"
                    onChange={handleInputChange}
                  />
                  ☐ 3 ou mais
                </label>
              </div>
            </div>
          </>
        )}

        <div className="form-section">
          <h3>● Você já recebeu algum prêmio ou benefício por pontuações na plataforma?</h3>
          <div className="radio-group">
            <label>
              <input
                type="radio"
                name="recebeuPremio"
                value="Sim"
                onChange={handleInputChange}
              />
              ( ) Sim
            </label>
            <label>
              <input
                type="radio"
                name="recebeuPremio"
                value="Não"
                onChange={handleInputChange}
              />
              ( ) Não
            </label>
            <label>
              <input
                type="radio"
                name="recebeuPremio"
                value="Não sabia que existiam prêmios"
                onChange={handleInputChange}
              />
              ( ) Não sabia que existiam prêmios
            </label>
          </div>
        </div>

        <div className="form-section">
          <h3>● Como você avalia a facilidade de uso do Ache Seu Pintor?</h3>
          <div className="rating-group">
            <label>
              <input
                type="radio"
                name="facilidadeUso"
                value="1"
                onChange={handleInputChange}
              />
              ⭐ Muito difícil
            </label>
            <label>
              <input
                type="radio"
                name="facilidadeUso"
                value="2"
                onChange={handleInputChange}
              />
              ⭐⭐ Difícil
            </label>
            <label>
              <input
                type="radio"
                name="facilidadeUso"
                value="3"
                onChange={handleInputChange}
              />
              ⭐⭐⭐ Neutro
            </label>
            <label>
              <input
                type="radio"
                name="facilidadeUso"
                value="4"
                onChange={handleInputChange}
              />
              ⭐⭐⭐⭐ Fácil
            </label>
            <label>
              <input
                type="radio"
                name="facilidadeUso"
                value="5"
                onChange={handleInputChange}
              />
              ⭐⭐⭐⭐⭐ Muito fácil
            </label>
          </div>
        </div>

        {(formData.facilidadeUso === '1' || formData.facilidadeUso === '2') && (
          <div className="form-section">
            <h3>● Em caso de "Difícil" ou "Muito Difícil", gostaria de explicar o porquê?</h3>
            <textarea
              name="dificuldadeUsoMotivo"
              value={formData.dificuldadeUsoMotivo}
              onChange={handleInputChange}
              placeholder="_____________________"
              className="text-input"
            />
          </div>
        )}

        <div className="form-section">
          <h3>● Como você avalia a qualidade dos clientes que entram em contato pela plataforma?</h3>
          <div className="rating-group">
            <label>
              <input
                type="radio"
                name="qualidadeClientes"
                value="1"
                onChange={handleInputChange}
              />
              ⭐ Muito ruim
            </label>
            <label>
              <input
                type="radio"
                name="qualidadeClientes"
                value="2"
                onChange={handleInputChange}
              />
              ⭐⭐ Ruim
            </label>
            <label>
              <input
                type="radio"
                name="qualidadeClientes"
                value="3"
                onChange={handleInputChange}
              />
              ⭐⭐⭐ Neutro
            </label>
            <label>
              <input
                type="radio"
                name="qualidadeClientes"
                value="4"
                onChange={handleInputChange}
              />
              ⭐⭐⭐⭐ Boa
            </label>
            <label>
              <input
                type="radio"
                name="qualidadeClientes"
                value="5"
                onChange={handleInputChange}
              />
              ⭐⭐⭐⭐⭐ Muito boa
            </label>
          </div>
        </div>

        {(formData.qualidadeClientes === '1' || formData.qualidadeClientes === '2') && (
          <div className="form-section">
            <h3>● Em caso de "Ruim" ou "Muito Ruim", gostaria de explicar o porquê</h3>
            <textarea
              name="qualidadeClientesMotivo"
              value={formData.qualidadeClientesMotivo}
              onChange={handleInputChange}
              placeholder="_______________"
              className="text-input"
            />
          </div>
        )}

        <div className="form-section">
          <h3>● Quer contar a sua história de sucesso com o Ache Seu Pintor? Deixe o seu número de telefone aqui:</h3>
          <p className="info-text">Um membro da equipe Sherwin-Williams entrará em contato com você.</p>
          <input
            type="tel"
            name="telefoneSucesso"
            value={formData.telefoneSucesso}
            onChange={handleInputChange}
            placeholder="______________________"
            className="text-input"
          />
        </div>

        <div className="form-section">
          <h3>● O que podemos melhorar para facilitar o seu trabalho e aumentar suas oportunidades?</h3>
          <textarea
            name="sugestoesMelhorias"
            value={formData.sugestoesMelhorias}
            onChange={handleInputChange}
            placeholder="______________________"
            className="text-input"
          />
        </div>

        <div className="form-actions">
          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? 'Enviando...' : 'Enviar Pesquisa'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PesquisaSatisfacao;
